export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-gradient-to-r from-primary-500 via-primary-600 to-accent-500">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              移动观看
            </h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed max-w-[480px] mx-auto lg:mx-0 mb-6">
              羞羞动漫在线观看全面适配移动端，手机浏览器直接访问即可享受下拉式流畅体验。无论iOS还是Android，高清蜜桃动漫在线随时随地想看就看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <span className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-apple-line text-lg"></i>
                iOS 适配
              </span>
              <span className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-android-line text-lg"></i>
                Android 适配
              </span>
              <span className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-global-line text-lg"></i>
                浏览器即开即看
              </span>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 h-48 md:w-56 md:h-56 rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20minimal%20illustration%20of%20a%20smartphone%20screen%20displaying%20anime%20character%20art%2C%20soft%20peach%20pink%20color%20scheme%2C%20clean%20UI%20mockup%2C%20warm%20gradient%20background%2C%20modern%20mobile%20design%2C%20elegant%20and%20simple%20composition&width=560&height=560&seq=app-section-qr&orientation=squarish"
                alt="羞羞动漫移动端观看"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}